export default [
  {
    name: "Schrift",
    properties: [
      {
        name: "Color",
        value: "color",
        type: "color",
      },
      {
        name: "Family",
        value: "font-family",
        type: "text",
      },
      {
        name: "Style",
        value: "font-style",
        type: "text",
        autocomplete: ["normal", "italic"],
      },
      {
        name: "Weight",
        value: "font-weight",
        type: "text",
        autocomplete: [
          "normal",
          "bold",
          "bolder",
          "lighter",
          "100",
          "200",
          "300",
          "400",
          "500",
          "600",
          "700",
          "800",
          "900",
        ],
      },
      {
        name: "Size",
        value: "font-size",
        type: "length",
        autocomplete: ["xx-small", "x-small", "small", "medium", "large", "x-large", "xx-large", "smaller", "larger"],
      },
      {
        name: "Line Height",
        value: "line-height",
        type: "number",
      },
      {
        name: "Letter Spacing",
        value: "letter-spacing",
        type: "number",
      },
      {
        name: "Transform",
        value: "text-transform",
        type: "text",
        autocomplete: ["none", "capitalize", "uppercase", "lowercase"],
      },
    ],
  },
  {
    name: "Fonts, Rendering, OpenType",
    properties: [
      {
        name: "Optical Size",
        value: "font-optical-sizing",
        type: "text",
        autocomplete: ["none", "auto"],
      },
      {
        name: "Adjust Size",
        value: "font-size-adjust",
        type: "number",
        autocomplete: ["none"],
      },
      {
        name: "Stretch",
        value: "font-stretch",
        type: ["percentage", "text"],
        autocomplete: [
          "ultra-condensed",
          "extra-condensed",
          "condensed",
          "semi-condensed",
          "normal",
          "semi-expanded",
          "expanded",
          "extra-expanded",
          "ultra-expanded",
        ],
      },
      {
        name: "Kerning",
        value: "font-kerning",
        type: "text",
        autocomplete: ["auto", "normal", "none"],
      },
      {
        name: "Font Variant Caps",
        value: "font-variant-caps",
        type: "text",
        autocomplete: [
          "normal",
          "small-caps",
          "all-small-caps",
          "petite-caps",
          "all-petite-caps",
          "unicase",
          "titling-caps",
        ],
      },
      {
        name: "Font Variant Ligatures",
        value: "font-variant-ligatures",
        type: "text",
        autocomplete: [
          "none",
          "normal",
          "common-ligatures",
          "no-common-ligatures",
          "discretionary-ligatures",
          "no-discretionary-ligatures",
          "historical-ligatures",
          "no-historical-ligatures",
          "contextual",
          "no-contextual",
        ],
      },
      {
        name: "Font Variant Numeric",
        value: "font-variant-numeric",
        values: "5",
        type: "text",
        autocomplete: [
          "normal",
          "ordinal",
          "slashed-zero",
          "lining-nums",
          "oldstyle-nums",
          "proportional-nums",
          "tabular-nums",
          "diagonal-fractions",
          "stacked-fractions",
        ],
      },
      {
        name: "Font Variant East Asian",
        value: "font-variant-east-asian",
        values: "3",
        type: "text",
        autocomplete: [
          "normal",
          "ruby",
          "jis78",
          "jis83",
          "jis90",
          "jis04",
          "simplified",
          "traditional",
          "full-width",
          "proportional-width",
        ],
      },
      {
        name: "Font Variant",
        value: "font-variant",
        type: "text",
        autocomplete: ["normal", "small-caps"],
      },
      {
        name: "Font Variation Settings",
        value: "font-variation-settings",
        values: "2",
        type: ["text", "number"],
        autocomplete: ["normal"],
      },
      {
        name: "Feature Settings",
        value: "font-feature-settings",
        type: "text",
      },
      {
        name: "Smoothing",
        value: "font-smoothing",
        type: "text",
        autocomplete: ["none", "auto", "antialiased", "subpixel-antialiased", "grayscale"],
      },
      {
        name: "Text Rendering",
        value: "font-rendering",
        type: "text",
        autocomplete: ["auto", "optimizeSpeed", "optimizeLegibility", "geometricPrecision"],
      },
    ],
  },
  
  {
    name: "Auszeichnung, Unterstreichung",
    properties: [
      {
        name: "Decoration Line",
        value: "text-decoration-line",
        values: 4,
        type: "text",
        autocomplete: ["none", "underline", "overline", "line-through", "blink"],
        shorthand: "text-decoration",
      },
      {
        name: "Decoration Skip Ink",
        value: "text-decoration-skip-ink",
        type: "text",
        autocomplete: ["none", "auto"],
        shorthand: "text-decoration",
      },
      {
        name: "Decoration Style",
        value: "text-decoration-style",
        type: "text",
        autocomplete: ["solid", "double", "dotted", "dashed", "wavy"],
        shorthand: "text-decoration",
      },
      {
        name: "Decoration Color",
        value: "text-decoration-color",
        type: "color",
        shorthand: "text-decoration",
      },
      {
        name: "Decoration",
        value: "text-decoration",
        type: "text",
      },
      {
        name: "Underline Position",
        value: "text-underline-position",
        type: "text",
        autocomplete: ["auto", "under", "left", "right"],
      },
      {
        name: "Shadow",
        value: "text-shadow",
        type: ["text", "color"],
      },
      {
        name: "Emphasis",
        value: "text-emphasis",
        type: "text",
      },
      {
        name: "Emphasis Style",
        value: "text-emphasis-style",
        values: 2,
        type: ["text", "string"],
        autocomplete: ["none", "filled", "open", "dot", "circle", "double-circle", "triangle", "sesame"],
        shorthand: "text-emphasis",
      },
      {
        name: "Emphasis Color",
        value: "text-emphasis-color",
        type: "color",
        shorthand: "text-emphasis",
      },
      {
        name: "Emphasis Position",
        value: "text-emphasis-position",
        values: 2,
        type: "text",
        autocomplete: ["over", "under", "left", "right"],
      },
    ],
  },
  {
    name: "Text, Absatz, Umbruch",
    properties: [
      {
        name: "Align",
        value: "text-align",
        type: "text",
        autocomplete: ["left", "center", "right", "justify", "start", "end", "match-parent"],
      },
      {
        name: "Align last Line",
        value: "text-align-last",
        type: "text",
        autocomplete: ["auto", "left", "center", "right", "justify", "start", "end"],
      },
      {
        name: "Justify",
        value: "text-justify",
        type: "text",
        autocomplete: ["none", "auto", "inter-word", "inter-character"],
      },
      {
        name: "Vertical Align",
        value: "vertical-align",
        type: ["text", "length", "percentage"],
        autocomplete: ["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"],
      },
      {
        name: "Indent",
        value: "text-indent",
        type: "length",
      },
      {
        name: "Word Spacing",
        value: "word-spacing",
        type: ["text", "length", "percentage"],
        autocomplete: ["normal"],
      },
      {
        name: "White Space",
        value: "white-space",
        type: "text",
        autocomplete: ["normal", "nowrap", "pre", "pre-wrap", "pre-line", "break-spaces"],
      },
      {
        name: "Tab Size",
        value: "tab-size",
        type: "length",
      },
      {
        name: "Overflow Wrap",
        value: "overflow-wrap",
        type: "text",
        autocomplete: ["normal", "break-word", "anywhere"],
      },
      {
        name: "Word Break",
        value: "word-break",
        type: "text",
        autocomplete: ["normal", "break-all", "keep-all"],
      },
      {
        name: "Hyphens",
        value: "hyphens",
        type: "text",
        autocomplete: ["none", "manually", "auto"],
      },
      {
        name: "Text Overflow",
        value: "text-overflow",
        type: "text",
        autocomplete: ["clip", "ellipsis"],
      },
      {
        name: "Content",
        value: "content",
        type: "text",
      },
      {
        name: "Quotes",
        value: "quotes",
        type: ["text", "string"],
        autocomplete: ["none"],
      },
      {
        name: "Direction",
        value: "direction",
        type: "text",
        autocomplete: ["ltr", "rtl"],
      },
      {
        name: "Orientation",
        value: "text-orientation",
        type: "text",
        autocomplete: ["mixed", "upright", "sideways", "sideways-right", "use-glyph-orientation"],
      },
      {
        name: "Combine Text",
        value: "text-combine-upright",
        type: "text",
        autocomplete: ["none", "all"],
      },
    ],
  },
  {
    name: "Spalten, Mehrspaltigkeit",
    properties: [
      {
        name: "Column Count",
        value: "column-count",
        type: "number",
        shorthand: "columns",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Column Width",
        value: "column-width",
        type: "number",
        shorthand: "columns",
      },
      {
        name: "Columns",
        value: "columns",
        type: "text",
      },
      {
        name: "Column Gap",
        value: "column-gap",
        type: "number",
      },
      {
        name: "Column Fill",
        value: "column-fill",
        type: "text",
        autocomplete: ["balance", "auto", "initial", "inherit"],
      },
      {
        name: "Rule Width",
        value: "column-rule-width",
        type: "length",
        shorthand: "column-rule",
      },
      {
        name: "Rule Style",
        value: "column-rule-style",
        type: "number",
        shorthand: "column-rule",
        autocomplete: [
          "none",
          "hidden",
          "dotted",
          "dashed",
          "solid",
          "double",
          "groove",
          "ridge",
          "inset",
          "outset",
          "initial",
          "inherit",
        ],
      },
      {
        name: "Rule Color",
        value: "column-rule-color",
        type: "color",
        shorthand: "column-rule",
      },
      {
        name: "Column Rule",
        value: "column-rule",
        type: "number",
      },
      {
        name: "Span Columns",
        value: "column-span",
        type: "text",
        autocomplete: ["all", "none", "initial", "inherit"],
      },
      {
        name: "Orphan Lines",
        value: "orphans",
        type: "number",
      },
      {
        name: "Widow Lines",
        value: "widows",
        type: "number",
      },
    ],
  },
  {
    name: "Listen",
    properties: [
      {
        name: "Style",
        value: "list-style",
        type: "text",
      },
      {
        name: "Type",
        value: "list-style-type",
        type: ["text", "string"],
        autocomplete: [
          "none",
          "disc",
          "circle",
          "square",
          "decimal",
          "georgian",
          "decimal-leading-zero",
          "lower-roman",
          "upper-roman",
          "lower-greek",
          "lower-latin",
          "upper-latin",
        ],
        shorthand: "list-style",
      },
      {
        name: "Image",
        value: "list-style-image",
        type: "text",
        shorthand: "list-style",
      },
      {
        name: "Position",
        value: "list-style-position",
        type: "text",
        autocomplete: ["inside", "outside"],
        shorthand: "list-style",
      },
      {
        name: "Increment Counter",
        value: "couter-increment",
        type: "number",
      },
      {
        name: "Reset Counter",
        value: "couter-reset",
        type: ["text", "string", "number"],
        autocomplete: ["none"],
      },
    ],
  },
  {
    name: "Tabellen",
    properties: [
      {
        name: "Layout",
        value: "table-layout",
        type: "text",
        autocomplete: ["fixed", "auto"],
      },
      {
        name: "Empty Cells",
        value: "empty-cells",
        type: "text",
        autocomplete: ["show", "hide"],
      },
      {
        name: "Caption",
        value: "caption-side",
        type: "text",
        autocomplete: ["top", "bottom"],
      },
    ],
  },
];
